import buildMetricValuesHook from '../utils/buildMetricValuesHook'

export const dhWbListLocationGroupGuestKpisConfigs = {
  googleRating: 'number',
  googleRatingCount: 'number',
  yelpRating: 'number',
  yelpRatingCount: 'number',
  deliveryAvgCustomerReviewScoreDoordash: 'number',
  deliveryReviewedOrderCountDoordash: 'number',
  qualtricsOsatPercent: 'percent',
  qualtricsOsatTotalSurveys: 'number',
  qualtricsOrderAccuracyPercent: 'percent',
  qualtricsOrderAccuracyTotalSurveys: 'number',
  qualtricsQualityOfFoodPercent: 'percent',
  qualtricsQualityOfFoodTotalSurveys: 'number',
  qualtricsMenuOptionsPercent: 'percent',
  qualtricsMenuOptionsTotalSurveys: 'number',
  qualtricsValuePercent: 'percent',
  qualtricsValueTotalSurveys: 'number',
  qualtricsEaseOfOrderingPercent: 'percent',
  qualtricsEaseOfOrderingTotalSurveys: 'number',
  qualtricsEmployeeFriendlinessPercent: 'percent',
  qualtricsEmployeeFriendlinessTotalSurveys: 'number',
  qualtricsSpeedOfServicePercent: 'percent',
  qualtricsSpeedOfServiceTotalSurveys: 'number',
  qualtricsCleanlinessPercent: 'percent',
  qualtricsCleanlinessTotalSurveys: 'number',
  qualtricsDriveThruWaitTimePercent: 'percent',
  qualtricsDriveThruWaitTimeTotalSurveys: 'number',
  deliveryCustomerPositiveRatingCountPercentDoordash: 'percent',
} as const

const useDhWbListLocationGroupGuestKpis = buildMetricValuesHook({
  groupFilterType: 'corporate',
  metrics: {
    codes: [
      'delivery_avg_customer_review_score_doordash',
      'delivery_reviewed_order_count_doordash',
      'delivery_customer_positive_rating_count_percent_doordash',
    ],
    groups: ['Expo Module - Guest', 'Qualtrics'],
  },
})

export default useDhWbListLocationGroupGuestKpis
